import { isDevModeActive } from '../services/loginService'

export const apiUrl = () => (isDevModeActive() ? '//leonls.kongsberg-ts.no/dev/api' : '//leonls.kongsberg-ts.no/api')
